import { Container, Box } from "@chakra-ui/react";
import Arrow from "assets/svg/other/arrow.svg";
//import Support from "assets/svg/other/support.svg";
import Buy from "assets/svg/other/buy.svg";
//assets
//import Cancel from "assets/svg/other/cancel.svg";
import Faq from "assets/svg/other/faq.svg";
import Fund from "assets/svg/other/fund.svg";
import Not from "assets/svg/other/notification.svg";
import Sell from "assets/svg/other/sell.svg";
import Send from "assets/svg/other/send.svg";
import Withdraw from "assets/svg/other/withdraw.svg";
import BCPL from "assets/svg/bcpl.svg";
// import Receive from "assets/svg/receive02.svg";

import Coms from "components/coms";
import Header from "components/dashHeader";
// import  Graph from 'components/ethGraph'
//import BitGraph from "components/Graphs/bitcoinGraphs";
import BitG2 from "components/Graphs/bitGraphs2";
// import { WrappedFiatWalletAction } from "components/WalletActions/FiatWalletActions";

// import PickCountry from 'components/pickCountry'
import HomeWallet from "components/homeWallet";
//import { useIntercom } from "react-use-intercom";
// components
import Sidemenu from "components/sidemenu";
//css
import "pages/styles/dashboard/Home.css";
import React, { Component } from "react";
import { Link, useHistory } from "react-router-dom";
import { useStore } from "store";

import toLower from "lodash/toLower";

// import { useAnnouncement } from "contexts/announcement";

//
// import Bitcoin from 'assets/svg/other/bitcoin.svg'
// import Eth from 'assets/svg/other/eth.svg'
// import Teth from 'assets/svg/other/tether.svg'
// import XRP from 'assets/svg/other/xrp.svg'
// import Lite from 'assets/svg/other/lite.svg'

// import Graph from 'assets/png/graph2.png'

export default function HomeComponent(props) {
  const { store, dispatch } = useStore();
  const history = useHistory();

  // const { setHistory } = useAnnouncement();

  const logoutUser = () => {
    dispatch({
      type: "LOGOUT",
      payload: { isSignedIn: false, token: undefined },
    });
  };

  // useEffect(() => {
  //   setHistory(history);
  //   //esling-disable-next-line
  // }, [history, setHistory]);

  return (
    <Home
      {...props}
      store={store}
      dispatch={dispatch}
      userData={store?.userData || {}}
      logoutUser={logoutUser}
      history={history}
    />
  );
}

class Home extends Component {
  constructor(props) {
    super(props);

    this.state = {
      unVerifiedShow: false,
      isLoaded: false,
      currency: "",
      selectedCurrency: "naira",
    };
    // this.handleCurrencyChange = this.handleCurrencyChange.bind(this);
  }

  async componentDidMount() {
    const userData = this.props.userData;
    if (userData?.verified !== true) {
      this.setState({
        unVerifiedShow: true,
      });
    }
  }

  handleCurrencyChange = (value) => {
    console.log(value, "VALUE");
    this.setState({
      selectedCurrency: value,
    });
  };

  userBaseCurrency = () => {
    const map = {
      nigeria: "ngn",
      ghana: "ghs",
      kenya: "kes",
    };

    return map[toLower(this.props?.userData?.country)];
  };

  render() {
    const currentPage = "Home";
    const logoutUser = () => this.props.logout();

    return (
      <div>
        <Sidemenu currentPage={currentPage} logoutUser={logoutUser} />
        <Header />

        {
          <section className="Home">
            <div className="home-container">
              <Container maxW={["100%", "container.xl"]} p={["0", "0", "1rem"]}>
                <div className="home-content">
                  <div className="home-top">
                    <h1> Dashboard </h1>
                  </div>

                  <div className="home-boxes">
                    <div className="home-box-bg h-box-m">
                      <div className="home-box-bg-top">
                        <HomeWallet
                          handleChange={this.handleCurrencyChange}
                          selectedCurrency={this.state.selectedCurrency}
                        />

                        {/* <WrappedFiatWalletAction
                          w="50%"
                          userData={this.props?.userData}
                        /> */}

                        <div className="hbbg-actions">
                          <div>
                            <Link to="/dashboard/homenotifications">
                              <img src={Not} alt="notification" />
                            </Link>
                          </div>

                          <div>
                            <a
                              rel="noreferrer"
                              target="_blank"
                              href="https://www.bitmama.io/faq"
                            >
                              <img src={Faq} alt="faq" />
                            </a>
                          </div>

                          <Coms />
                        </div>
                      </div>

                      {/* <BitGraph /> */}
                      <BitG2 selectedCurrency={this.state.selectedCurrency} />
                    </div>
                    <div className="home-box-sm">
                      <h2>Actions</h2>
                      <Link to="/dashboard/homebuy" className="hbsm-single">
                        <div className="hb-actions-left">
                          <img src={Buy} alt="" />
                          <p>Buy</p>
                        </div>
                        <div className="hb-actions-right">
                          <img src={Arrow} alt="" />
                        </div>
                      </Link>
                      <Link to="/dashboard/homesell" className="hbsm-single">
                        <div className="hb-actions-left">
                          <img src={Sell} alt="" />
                          <p>Sell</p>
                        </div>
                        <div className="hb-actions-right">
                          <img src={Arrow} alt="arrow" />
                        </div>
                      </Link>
                      <div
                        id="error-info2"
                        className="err-auth zindex animate__animated animate__slideInDown"
                      >
                        <p>
                          <strong>{this.state.incorrectError}</strong>
                        </p>
                      </div>
                      {/* <Link to="/dashboard/homefundwallet" className="hbsm-single">
                    <div className="hb-actions-left">
                      <img src={Fund} alt="" />
                      <p>Fund Wallet</p>
                    </div>
                    <div className="hb-actions-right">
                      <img src={Arrow} alt="" />
                    </div>
                  </Link> */}

                      <Link
                        to={`/dashboard/wallet/fund/${this.userBaseCurrency()}`}
                        className="hbsm-single"
                      >
                        {/* <div className="hbsm-single disable-temp"> */}
                        <div className="hb-actions-left">
                          <img src={Fund} alt="" />
                          <p>Fund Wallet</p>
                        </div>
                        <div className="hb-actions-right">
                          <img src={Arrow} alt="" />
                        </div>
                        {/* </div> */}
                      </Link>

                      <Link
                        to={`/dashboard/wallet/withdraw/${this.userBaseCurrency()}`}
                        className="hbsm-single"
                      >
                        {/* <div className="hbsm-single disable-temp"> */}
                        <div className="hb-actions-left">
                          <img src={Withdraw} alt="" />
                          <p>Withdraw</p>
                        </div>
                        <div className="hb-actions-right">
                          <img src={Arrow} alt="" />
                        </div>
                        {/* </div> */}
                      </Link>
                      <Link to={`/dashboard/bcpl`} className="hbsm-single">
                        {/* <div className="hbsm-single disable-temp"> */}
                        <div className="hb-actions-left">
                          <Box
                            w="71px"
                            h="65px"
                            borderRadius="16px"
                            bg="#02472a36"
                            d="flex"
                            justifyContent="center"
                            alignItems="center"
                          >
                            <img src={BCPL} alt="" />
                          </Box>
                          <p>
                            Buy Crypto, <br />
                            Pay Later
                          </p>
                        </div>
                        <div className="hb-actions-right">
                          <img src={Arrow} alt="" />
                        </div>
                        {/* </div> */}
                      </Link>
                      {/* <Link to="/dashboard/homesend" className="hbsm-single"> */}
                      <div className="hbsm-single disable-temp">
                        <div className="hb-actions-left">
                          <img src={Send} alt="" />
                          <p>Send Money</p>
                        </div>
                        <div className="hb-actions-right">
                          <img src={Arrow} alt="" />
                        </div>
                      </div>
                      {/* </Link> */}
                      {/* <Link to="/dashboard/homereceive" className="hbsm-single"> */}
                      {/* <div className="hbsm-single disable-temp">
                        <div className="hb-actions-left">
                          <img src={Receive} alt="" />
                          <p> Receive Money</p>
                        </div>
                        <div className="hb-actions-right">
                          <img src={Arrow} alt="" />
                        </div>
                      </div> */}
                      {/* </Link> */}
                    </div>
                  </div>
                </div>
              </Container>
            </div>
          </section>
        }
      </div>
    );
  }
}
